const REASONS = [
  {
    n: "01",
    title: "Founded by a Senior Intelligent Automation Architect",
    desc: "12+ years of enterprise automation experience — building production systems for Fortune 500 and high-growth Indian businesses.",
  },
  {
    n: "02",
    title: "Deep expertise across the AI + automation stack",
    desc: "UiPath, Agentic AI, SAP automation, Intelligent Document Processing, and Generative AI — production-grade, not proof-of-concept.",
  },
  {
    n: "03",
    title: "Business-first approach focused on ROI",
    desc: "Every project is anchored to a clear business outcome — cost reduction, revenue growth, or capacity expansion. Tech serves business, not the other way around.",
  },
  {
    n: "04",
    title: "Enterprise-grade design, SMB-friendly delivery",
    desc: "Scalable architecture, secure-by-default integrations, and well-instrumented systems — packaged with the speed and pragmatism Indian SMBs need.",
  },
  {
    n: "05",
    title: "Built for Indian SMBs and mid-market companies",
    desc: "Multilingual (Telugu / Hindi / English), WhatsApp-native, sensitive to Indian working culture, GST / Tally / SAP-ready out of the box.",
  },
  {
    n: "06",
    title: "Fast implementation roadmap",
    desc: "Assessment in week 1. First AI employee live in 2–4 weeks. Continuous improvement from week 5 onwards. No 18-month consulting engagements.",
  },
];

const WhyAria = () => (
  <section id="why-aria" className="section bg-cream" data-bg="cream" data-testid="why-aria-section">
    <div className="section-inner">
      <div className="reveal">
        <span className="eyebrow">Why Aria</span>
        <h2 className="section-h2">
          Engineered by enterprise.<br />
          <span className="serif">Built for you</span>.
        </h2>
        <p className="section-sub">
          You don't need another tool. You need a partner who has done this
          before, knows what production looks like, and can deliver it for your scale.
        </p>
      </div>

      <div className="why-grid reveal">
        {REASONS.map((r) => (
          <article key={r.n} className="why-card" data-testid={`why-${r.n}`}>
            <div className="why-num">{r.n}</div>
            <h3 className="why-title">{r.title}</h3>
            <p className="why-desc">{r.desc}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default WhyAria;
